import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { X, ArrowRight } from "lucide-react";
import { api } from "@/lib/api";

const THEMES = {
  accent: "bg-accent text-white",
  primary: "bg-primary text-white",
  dark: "steel-texture text-white",
};

export default function PromoBanner() {
  const [promo, setPromo] = useState(null);
  const [hidden, setHidden] = useState(true);

  useEffect(() => {
    api.get("/settings/promo").then((r) => {
      setPromo(r.data);
      if (r.data?.enabled && r.data?.message) {
        const key = `promo_dismiss_${r.data.message.slice(0, 60)}`;
        setHidden(localStorage.getItem(key) === "1");
      }
    }).catch(() => {});
  }, []);

  if (!promo?.enabled || !promo.message || hidden) return null;

  const dismiss = () => {
    localStorage.setItem(`promo_dismiss_${promo.message.slice(0, 60)}`, "1");
    setHidden(true);
  };
  const isInternal = promo.cta_href && promo.cta_href.startsWith("/");

  return (
    <div className={`${THEMES[promo.theme] || THEMES.accent} relative`} data-testid="promo-banner">
      <div className="max-w-7xl mx-auto px-4 py-2.5 flex items-center justify-center gap-3 text-sm text-center">
        <span className="font-medium">{promo.message}</span>
        {promo.cta_label && promo.cta_href && (
          isInternal ? (
            <Link to={promo.cta_href} data-testid="promo-cta" className="inline-flex items-center gap-1 font-bold underline underline-offset-2 hover:no-underline shrink-0">
              {promo.cta_label} <ArrowRight className="w-3.5 h-3.5" />
            </Link>
          ) : (
            <a href={promo.cta_href} target="_blank" rel="noopener noreferrer" data-testid="promo-cta" className="inline-flex items-center gap-1 font-bold underline underline-offset-2 hover:no-underline shrink-0">
              {promo.cta_label} <ArrowRight className="w-3.5 h-3.5" />
            </a>
          )
        )}
      </div>
      <button onClick={dismiss} data-testid="promo-dismiss" aria-label="Dismiss"
        className="absolute right-3 top-1/2 -translate-y-1/2 p-1 rounded hover:bg-white/20 transition-colors">
        <X className="w-4 h-4" />
      </button>
    </div>
  );
}
